import React, {useState} from "react";
import clsx from "clsx";
import {cloneDeep} from 'lodash'
import {SUPPORT_URL} from "assets/constants";
import {selectAllMessages} from "redux/actions";
import {Link, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
//Material UI Component
import {
    Avatar,
    Button,
    ButtonGroup,
    Checkbox,
    FormControlLabel,
    Grid,
    Hidden,
    Popover,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import {AvatarGroup} from "@material-ui/lab";
import StarIcon from '@material-ui/icons/Star';
import {makeStyles} from "@material-ui/styles";
import PeopleIcon from '@material-ui/icons/People';
import AttachmentIcon from '@material-ui/icons/Attachment';
import StarOutlineIcon from "@material-ui/icons/StarOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import LabelImportantIcon from "@material-ui/icons/LabelImportant";
import LabelImportantOutlinedIcon from "@material-ui/icons/LabelImportantOutlined";


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        opacity: 0.9,
        paddingBottom: 2.5,
        paddingTop: 2.5,
        border: "0.5px solid transparent",
        "&:hover": {
            opacity: 1,
            border: "0.5px solid black",
            cursor: "pointer",
        },
    },
    labelAndSubject: {
        "& > *": {
            margin: theme.spacing(0.5),
        },
    },
    Unread: {
        fontWeight: "bold",
        backgroundColor: "#fff",
    },
    container: {
        textDecoration: "none",
        textDecorationColor: "none",
        color: "#000",
        [theme.breakpoints.down("lg")]: {
            minWidth: '4em'
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: '2em'
        }

    },
    iconContainer: {
        padding: '0.2em',
        "&:hover": {
            color: "#efd971",
            opacity: 0.7,
        },
    },
    popoverContent: {
        textDecoration: 'none',
        fontWeight: 500,
        fontSize: '1rem',
        color: '#000'
    },
    paper: {
        padding: theme.spacing(1),
    },
    avatar: {
        height: '35px',
        width: '35px'
    },
    checkButton: {
        padding: 0,
        margin: 0,
        minWidth: '5px',
        '&.MuiCheckbox-root': {
            padding: '5em'
        },
        '& svg': {
            height: '1em',
            width: '1em'
        }
    },
    buttonGroup: {
        padding: 0,
        border: 0,
        '&:hover': {
            backgroundColor: 'inherit'
        },
    }
}));

const Messages = ({message, memberType, handleList, paidUser}) => {
    const theme = useTheme();
    const {tab} = useParams();
    const classes = useStyles();
    const dispatch = useDispatch();

    const {selected} = useSelector(state => state.messages)

    const iphone5 = useMediaQuery("@media (max-width:320px)");
    const android = useMediaQuery("@media (max-width:360px)");
    const iphone8 = useMediaQuery("@media (max-width:375px)");
    const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))
    const matchesMD = useMediaQuery(theme.breakpoints.down('md'))
    const iphone8plus = useMediaQuery("@media (max-width:414px)");

    const {status, attachments, display_name, short_msg, date, id, multiple_sent, color, multiple_user} = message;
    // const handleMessageLocked() = (["Standard", "Basic"].includes(memberType) || !paidUser) && tab === 'verified';
    const subscriptionText = `You are a ${memberType} Subscribe. If you wish to access the query kindly generate request for Subscription.`
    const state = {sentList: multiple_sent ? multiple_user : false, previousPath: tab};

    const [anchorEl, setAnchorEl] = useState(null);


    const handlePopover = (event) => setAnchorEl(anchorEl ? null : event.currentTarget);
    const handleReadClass = () => {
        if (tab === 'sent')
            return '';
        else if (status === 'Unread')
            return classes.Unread
    }
    const handleMessageLocked = () => {
        if (tab === "verified") {
            if (["Standard", "Basic"].includes(memberType))
                return true;
            else if (["Secretary", "Committee", "Visitor"].includes(memberType))
                return false;
            else if (paidUser === false)
                return true;
        } else
            return false;
    }

    const handleChange = (id) => {
        const currentIndex = selected.indexOf(id);
        const newSelected = cloneDeep(selected);

        if (currentIndex === -1)
            newSelected.push(id);
        else
            newSelected.splice(currentIndex, 1);

        dispatch(selectAllMessages(newSelected))
    };

    const handleCheckbox = (event, id) => {
        event.preventDefault();
        handleChange(id);
    }

    const Popup = () => {
        return <Popover id="popover"
                        classes={{paper: classes.paper,}}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        anchorOrigin={{vertical: "bottom", horizontal: "left",}}
                        transformOrigin={{vertical: "top", horizontal: "left"}}
                        onClose={handlePopover}>
            <a className={classes.popoverContent}
               href={SUPPORT_URL}
               target="_blank"
               rel='noreferrer'>
                <Typography>{subscriptionText}</Typography>
            </a>
        </Popover>
    };

    const list = (
        <Grid
            container
            className={clsx(classes.root, handleReadClass())}
            direction="row"
            alignItems="center">
            <Grid item>
                <Grid item container alignItems='center'>
                    <Grid item>
                        <ButtonGroup disableRipple>
                            <Button component={"span"} className={classes.buttonGroup}>
                                <FormControlLabel
                                    classes={{root: classes.checkButton}}
                                    control={<Checkbox
                                        checked={selected.indexOf(id) !== -1}
                                        disabled={handleMessageLocked()}
                                        onChange={() => handleChange(id)}
                                        color="primary"
                                        style={{padding: 3}} name="checkedH"/>}
                                    label=''
                                />
                                <FormControlLabel classes={{root: classes.checkButton}}
                                                  control={<Checkbox
                                                      color='primary'
                                                      disabled={handleMessageLocked()}
                                                      style={{padding: 3}}
                                                      icon={<StarOutlineIcon/>}
                                                      checkedIcon={<StarIcon/>}
                                                      name="checkedH"/>}
                                                  label=''
                                />
                                <FormControlLabel classes={{root: classes.checkButton}}
                                                  control={<Checkbox style={{padding: 3}}
                                                                     icon={<LabelImportantOutlinedIcon/>}
                                                                     checkedIcon={<LabelImportantIcon/>}
                                                                     disabled={handleMessageLocked()}
                                                                     color='primary'
                                                                     name="checkedH"/>}
                                                  label=''
                                />
                            </Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sm={3} md={3}>
                <Grid
                    item
                    container
                    className={classes.container}
                    component={handleMessageLocked() ? Typography : Link}
                    onClick={handlePopover}
                    to={{pathname: `/message/${id}`, state}}
                    spacing={2}
                    alignItems="center"
                >
                    {
                        // SENT LAYOUT CHANGE
                        multiple_sent ? (
                            <>
                                <Hidden smDown>
                                    <Grid item sm={5}>
                                        <AvatarGroup max={matchesMD ? 3 : 4} classes={{avatar: classes.avatar}}>
                                            {['M', 'U', 'L', 'T', 'I'].map((letter, index) => (
                                                <Avatar key={index}> {letter} </Avatar>
                                            ))}
                                        </AvatarGroup>
                                    </Grid>
                                </Hidden>
                                <Grid item sm>
                                    <Button size={matchesMD ? 'small' : 'medium'} variant={'outlined'}
                                            onClick={handleList(true, multiple_user)}>
                                        User List
                                    </Button>
                                </Grid>
                            </>
                        ) : (
                            <Grid item container spacing={2} alignItems={'center'}>
                                <Grid item>
                                    <Avatar classes={{root: classes.avatar}} style={color}>{display_name[0]}</Avatar>
                                </Grid>
                                <Grid item sm={8}>
                                    <Typography noWrap className={clsx(handleReadClass())}>{display_name}</Typography>
                                </Grid>
                            </Grid>
                        )
                    }
                </Grid>
            </Grid>
            <Grid item sm container
                  className={classes.container}
                  component={handleMessageLocked() ? Typography : Link}
                  onClick={handlePopover}
                  to={{pathname: `/message/${id}`, state}}
            >
                <Typography noWrap className={clsx(handleReadClass())}
                >
                    {short_msg}
                </Typography>
            </Grid>
            <Grid item sm={2} md={2} container justify={"flex-end"}>
                {attachments?.length ? <Grid item><AttachmentIcon/></Grid> : null}
                <Grid item>
                    <Typography noWrap variant={"body1"} className={clsx(handleReadClass())}>
                        {date}
                    </Typography>
                </Grid>
            </Grid>
            {handleMessageLocked() && (
                <>
                    <Grid item>
                        <LockOutlinedIcon/>
                    </Grid>
                    <Grid item>
                        <Popup/>
                    </Grid>
                </>
            )}
        </Grid>
    )

    const mobileList = (

        <Grid item container
              component={handleMessageLocked() ? Typography : Link}
              onClick={handlePopover}
              to={{pathname: `/message/${id}`, state}}
              className={clsx(classes.root, classes.container, handleReadClass())}
              alignItems='center' style={{flexWrap: 'nowrap'}}>
            <Grid item style={{padding: '0.3em 0.5em'}} onClick={(event) => handleCheckbox(event, message.id)}>
                {selected.includes(message.id)
                    ? <Checkbox
                        // style={message.color}
                        disabled={handleMessageLocked()}
                        checked={selected.indexOf(id) !== -1}
                        color="primary"/>
                    : <Avatar classes={{root: classes.avatar}} style={color}>{display_name[0]}</Avatar>
                }
            </Grid>
            <Grid item xs container direction={"column"} alignItems={'center'} style={{}}>
                <Grid item xs container justify="space-between">
                    <Grid item style={{maxWidth: '100%'}}>
                        {
                            multiple_sent
                                ? <Button startIcon={<PeopleIcon/>} variant={"outlined"} size={'small'}
                                          onClick={handleList(true, multiple_user)}>sent User List</Button>
                                : <Typography noWrap
                                              className={clsx(handleReadClass())}
                                >
                                    {display_name}
                                </Typography>
                        }
                    </Grid>
                    <Grid item>
                        <Typography className={clsx(handleReadClass())}>
                            {date}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs container justify="space-between">
                    <Grid item style={{
                        width: iphone5
                            ? '11em'
                            : android
                                ? '15em'
                                : iphone8
                                    ? '16em'
                                    : iphone8plus
                                        ? '18em'
                                        : '20em'
                    }}>
                        <Typography noWrap className={clsx(handleReadClass())}>
                            {short_msg}
                        </Typography>
                    </Grid>
                    <Grid item container xs={2} justify={"flex-end"}>
                        {handleMessageLocked() && (<>
                            <Grid item><LockOutlinedIcon/></Grid>
                            <Grid item> <Popup/> </Grid>
                        </>)}
                        {attachments?.length ? <Grid item><AttachmentIcon/></Grid> : null}
                        {/*<Grid item><FormControlLabel onClick={(e) => e.preventDefault()}
                                                     classes={{root: classes.checkButton}}
                                                     control={<Checkbox
                                                         color='primary'
                                                         disabled={handleMessageLocked()}
                                                         style={{padding: 3}}
                                                         icon={<StarOutlineIcon/>}
                                                         checkedIcon={<StarIcon/>}
                                                         name="checkedH"/>}
                                                     label=''
                        /></Grid>*/}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )

    return (
        <>
            {matchesXS ? mobileList : list}
        </>
    );
};
export default Messages;
